import React from "react";

//MUI
import styled from "@emotion/styled";
import Dialog from '@mui/material/Dialog';
import Typography from "@mui/material/Typography";

//components
import CustomButton from "../Common/CustomButton";

const Container = styled("div")(({ theme }) => ({
  width: "100%",
  "& .text_info": {
    padding: "1.7rem 0 1rem 1rem",
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    "& .del_text_style": {
      fontSize: "15px",
      color: "#1B1C1E",
      fontWeight: "500",
      [theme.breakpoints.down("xl")]: {
        fontSize: "14px",
      },
      [theme.breakpoints.down("lg")]: {
        fontSize: "13px",
      },
    },
  },
  "& .btn_container": {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    gap: "0.5rem",
    padding: "0 0.5rem 1rem 0.5rem",
    "& .cancel_btn_style": {
      border: "1px solid #E5E5E5",
      borderRadius: "4px",
      "& .can_text": {
        color: "#253A6A",
        fontSize: "14px",
        [theme.breakpoints.down("xl")]: {
          fontSize: "13px",
        },
        [theme.breakpoints.down("lg")]: {
          fontSize: "12px",
        },
      }
    },
    "& .del_btn_style": {
      background: "#253A6A",
      "&.Mui-disabled": {
        background: "#A0A0A0", // Example disabled color
        cursor: "not-allowed",
        opacity: 0.6,
      },
      "& .app_text": {
        color: "#FFFFFF",
        fontSize: "14px",
        [theme.breakpoints.down("xl")]: {
          fontSize: "13px",
        },
        [theme.breakpoints.down("lg")]: {
          fontSize: "12px",
        },
      },
    },
  },
}));

const FinalConfirmation = (props) => {
  const { onClose, open, onConfirm, message, disableConfirmButton } = props;

  const handleClose = () => {
    onClose();
  };

  return (
    <Dialog
      onClose={handleClose}
      open={open}
      fullWidth
      maxWidth={"xs"}
    >
      <Container>
        <div className="text_info">
          <Typography className="del_text_style">{message}</Typography>
        </div>
        <div className="btn_container">
          <CustomButton
            onClick={handleClose}
            className="cancel_btn_style"
            variant="outlined"
          >
            <Typography className="can_text">Cancel</Typography>
          </CustomButton>
          <CustomButton
            variant="contained"
            className="del_btn_style"
            onClick={onConfirm}
            disabled={disableConfirmButton ? true : false}
          >
            <Typography className="app_text">Yes</Typography>
          </CustomButton>
        </div>
      </Container>
    </Dialog>
  );
};

export default FinalConfirmation;